import { openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderSlot as _renderSlot, normalizeClass as _normalizeClass, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = ["type"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("button", {
    class: _normalizeClass(["btn", {
      'btn-disabled': $props.disabled,
      'btn-block': $props.block,
      'btn-primary': $props.primary,
      'btn-loading': $props.loading,
      'btn-md': $props.md
    }]),
    type: $props.type,
    onClick: _cache[0] || (_cache[0] = ($event: any) => ($setup.emit('click')))
  }, [
    ($props.loading)
      ? (_openBlock(), _createBlock($setup["ClipLoader"], {
          key: 0,
          loading: "",
          class: "loader",
          size: "14px"
        }))
      : _createCommentVNode("", true),
    _renderSlot(_ctx.$slots, "default")
  ], 10, _hoisted_1))
}